import React, { useMemo, useState } from "react";
import ModalEncaminharSuporte from "./ModalEncaminharSuporte";
import "../../sass/components/projetoFluxoChamado.scss";

const norm = (valor) => (valor == null ? "" : String(valor).trim());

const statusCanonico = (status) =>
  norm(status)
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s*-\s*/g, "_")
    .replace(/\s+/g, "_");

const STATUS_INFO = {
  TESTADO_APROVADO: {
    label: "Pronto para retorno",
    description:
      "O projeto foi testado e aprovado. Encaminhe ao suporte para contato com o cliente.",
    tone: "approved",
  },
  AGUARDANDO_RETORNO_CLIENTE: {
    label: "Aguardando cliente",
    description:
      "O chamado de retorno já foi criado e está sob responsabilidade do suporte.",
    tone: "waiting",
  },
  REAJUSTE: {
    label: "Retornado para reajuste",
    description:
      "O cliente informou que o problema continua. O projeto voltou à fila de desenvolvimento.",
    tone: "rework",
  },
  CONCLUIDO: {
    label: "Cliente confirmou",
    description:
      "O suporte registrou a confirmação do cliente e concluiu o ciclo.",
    tone: "done",
  },
};

const ProjetoFluxoChamado = ({
  projeto,
  funcionario,
  codFunc,
  autorId,
  onUpdated,
  compact = false,
}) => {
  const [modalAberto, setModalAberto] = useState(false);

  const idChamadoOrigem =
    projeto?.ID_CHAMADO_ORIGEM ?? projeto?.idChamadoOrigem ?? null;
  const status = statusCanonico(projeto?.STATUS ?? projeto?.status);
  const info = STATUS_INFO[status] || {
    label: "Originado de chamado",
    description:
      "Este projeto segue o fluxo obrigatório de teste, aprovação e retorno ao cliente.",
    tone: "origin",
  };

  const retornoAberto = useMemo(
    () =>
      projeto?.chamadoRetornoAberto ||
      (Array.isArray(projeto?.chamadosRetorno)
        ? projeto.chamadosRetorno.find(
            (item) => String(item?.ResolvidoNao ?? "0") === "0",
          )
        : null),
    [projeto],
  );

  if (!idChamadoOrigem) return null;

  return (
    <>
      <section className={`projeto-fluxo-chamado ${info.tone} ${compact ? "compact" : ""}`}>
        <div className="pfc-icon" aria-hidden="true">
          ↗
        </div>
        <div className="pfc-main">
          <div className="pfc-title-row">
            <span className="pfc-origin-badge">
              Originado do chamado #{idChamadoOrigem}
            </span>
            <span className={`pfc-state ${info.tone}`}>{info.label}</span>
          </div>
          {!compact ? <p>{info.description}</p> : null}
          {retornoAberto ? (
            <small>
              Chamado de retorno aberto: <strong>#{retornoAberto.ID}</strong>
            </small>
          ) : null}
        </div>

        {status === "TESTADO_APROVADO" ? (
          <button
            type="button"
            className="pfc-action"
            onClick={() => setModalAberto(true)}
          >
            Encaminhar ao suporte
          </button>
        ) : null}
      </section>

      <ModalEncaminharSuporte
        isOpen={modalAberto}
        onClose={() => setModalAberto(false)}
        projeto={projeto}
        funcionario={funcionario}
        codFunc={codFunc}
        autorId={autorId}
        onSuccess={onUpdated}
      />
    </>
  );
};

export default ProjetoFluxoChamado;
